module.exports = __webpack_public_path__ + "static/media/truck-moving.addfd909.svg";